import React from 'react'
import { useTranslation } from 'next-i18next'
import { getBreadcrumbs } from './getBreadcrumbs'
import type { CategoryInterface, Maybe } from '@pylot-data/pylotschema'
import { ProductInterface, CmsPage } from '@pylot-data/fwrdschema'
import { useStoreConfig } from 'config/hooks/useStoreConfig'
import Head from 'next/head'
import { BlogBreadCrumbsDetails } from '@components/seo/src/Blog/BlogSchema'

type BreadcrumbsProps = {
    product?: Maybe<ProductInterface>
    cmsPage?: Maybe<CmsPage>
    category?: Maybe<CategoryInterface>
    pathname: string
    titleOverride?: string
    blogBreadCrumbs?: BlogBreadCrumbsDetails
}

export const Breadcrumbs = ({
    product,
    category,
    cmsPage,
    pathname,
    titleOverride,
    blogBreadCrumbs
}: BreadcrumbsProps): JSX.Element | null => {
    const { t } = useTranslation(['common'])
    const config = useStoreConfig()

    const breadcrumbItems = getBreadcrumbs({
        product,
        category,
        cmsPage,
        pathname,
        t,
        titleOverride,
        config,
        blogBreadCrumbs
    })

    if (
        !product &&
        !category &&
        !cmsPage &&
        !blogBreadCrumbs &&
        pathname != ''
    ) {
        return null
    }

    const breadcrumbData = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbItems
    }

    return breadcrumbItems ? (
        <Head>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(
                        product ? breadcrumbItems : breadcrumbData,
                        null,
                        '\t'
                    )
                }}
            />
        </Head>
    ) : null
}
